import React from 'react';
import { FiEdit2, FiTrash2, FiBookOpen, FiTarget, FiGrid, FiEye, FiBox, FiFileText, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { FaBuilding, FaUniversity, FaLanguage } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import AccountingSidebar from '../components/AccountingSidebar';

export default function CustomerInvoice() {
  const navigate = useNavigate();

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <AccountingSidebar />
      <div className="flex-1 overflow-y-auto relative flex flex-col">
        {/* Sub Navigation Tabs */}
        <div className="flex bg-[#a6e4e7] pt-2 px-0 shadow-sm relative z-10 border-b border-[#8ed1d4] shrink-0">
          <div className="px-4 py-2 bg-white text-gray-800 text-[13px] flex items-center shadow-[0_-2px_4px_rgba(0,0,0,0.05)] rounded-t-sm ml-2 font-medium">
            <FiFileText className="mr-1.5 text-gray-500" />
            Customer invoice
          </div>
          <div className="px-4 py-2 text-gray-700 text-[13px] hover:bg-white/30 cursor-pointer transition-colors">Contacts/Addresses</div>
          <div className="px-4 py-2 text-gray-700 text-[13px] hover:bg-white/30 cursor-pointer transition-colors">Credit transfer</div>
          <div className="px-4 py-2 text-gray-700 text-[13px] hover:bg-white/30 cursor-pointer transition-colors">MoceanAPI SMS</div>
          <div className="px-4 py-2 text-gray-700 text-[13px] hover:bg-white/30 cursor-pointer transition-colors">Notes</div>
          <div className="px-4 py-2 text-gray-700 text-[13px] hover:bg-white/30 cursor-pointer transition-colors">Linked files</div>
        </div>

        <div className="p-5 flex-1 flex flex-col">
          {/* Header Section */}
          <div className="flex justify-between items-start mb-6">
            <div className="flex items-start space-x-4">
              <div className="w-[42px] h-[46px] bg-white border border-gray-200 shadow-sm flex flex-col relative overflow-hidden shrink-0 mt-1">
                <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-[#5bc0be]"></div>
                <div className="flex-1 flex items-center justify-center text-teal-600 font-black text-[12px] leading-none pt-1 pl-1">EL</div>
                <div className="flex-1 flex items-center justify-center text-teal-600 font-black text-[14px] leading-none pb-1 pl-1">$</div>
              </div>
              <div>
                <h2 className="text-[22px] font-bold text-[#008080] leading-none mb-2">FA2605-0041</h2>
                <div className="text-[13px] grid grid-cols-[100px_1fr] gap-y-1.5 gap-x-2 items-center">
                  <div className="text-gray-600 flex items-center">
                    Ref. customer <FiEdit2 className="ml-1 text-gray-300 w-3 h-3 cursor-pointer hover:text-gray-500" /> <span className="ml-1">:</span>
                  </div>
                  <div className="text-gray-800">CU2602-0010</div>
                  <div className="text-gray-600 flex items-center">
                    Third-party <span className="ml-1">:</span>
                  </div>
                  <div className="text-gray-800 flex items-center font-medium">
                    <FaBuilding className="text-[#800080] mr-1.5" />
                    WONG CHING YEE (WONG CHING YEE) (Other invoices)
                  </div>
                  <div className="text-gray-600 flex items-center">
                    Project <FiEdit2 className="ml-1 text-gray-300 w-3 h-3 cursor-pointer hover:text-gray-500" /> <span className="ml-1">:</span>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col items-end space-y-3">
              <div className="flex items-center space-x-3 text-[14px]">
                <Link to="/sales/records" className="font-bold text-[#0000a0] hover:underline">Back to list</Link>
                <div className="flex items-center space-x-2">
                  <FiChevronLeft className="text-gray-300 text-xl cursor-not-allowed" />
                  <FiChevronRight className="text-black text-xl cursor-pointer hover:opacity-70" />
                </div>
              </div>
              <div className="border border-[#b7eb8f] px-4 py-1.5 text-[#008000] text-[13px] bg-[#e6f8e6] rounded-sm shadow-sm font-bold">
                Paid
              </div>
              <div className="text-gray-400 text-[12px]">
                Not yet transferred to accounting
              </div>
            </div>
          </div>

          {/* Details Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8">
            <div>
              <table className="w-full text-[12px] border-none">
                <tbody>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 text-gray-500 border-none w-[35%]">Type</td>
                    <td className="py-2.5 border-none text-gray-800">
                      <span className="bg-[#f5f5f5] px-2.5 py-1 rounded-[3px] border border-gray-200 text-[11px] text-gray-600">Standard invoice</span>
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 text-gray-500 border-none align-top pt-3">Discounts</td>
                    <td className="py-2.5 border-none text-[#999999] text-[11px] leading-relaxed">
                      This customer has no relative discount by default.<br/>
                      This customer has no discount credit available.
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 text-gray-500 border-none flex items-center">Invoice date</td>
                    <td className="py-2.5 border-none text-gray-800">05/20/2026</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 text-gray-500 border-none flex items-center">Payment Terms <FiEdit2 className="ml-1 text-gray-300 w-3 h-3 cursor-pointer hover:text-gray-500" /></td>
                    <td className="py-2.5 border-none text-gray-800">Due Upon Receipt</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 text-gray-500 border-none flex items-center">Payment due on <FiEdit2 className="ml-1 text-gray-300 w-3 h-3 cursor-pointer hover:text-gray-500" /></td>
                    <td className="py-2.5 border-none text-gray-800">05/21/2026</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 text-gray-500 border-none flex items-center">Payment method <FiEdit2 className="ml-1 text-gray-300 w-3 h-3 cursor-pointer hover:text-gray-500" /></td>
                    <td className="py-2.5 border-none text-gray-800">Bank transfer</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 text-gray-500 border-none flex items-center">Currency</td>
                    <td className="py-2.5 border-none text-gray-800">HKD - Hong Kong Dollar</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 text-gray-500 border-none flex items-center">Bank account <FiEdit2 className="ml-1 text-gray-300 w-3 h-3 cursor-pointer hover:text-gray-500" /></td>
                    <td className="py-2.5 border-none text-teal-700"><FaUniversity className="inline mr-1 text-[#a08a50]" /> BOC</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 text-gray-500 border-none flex items-center">Incoterms <FiEdit2 className="ml-1 text-gray-300 w-3 h-3 cursor-pointer hover:text-gray-500" /></td>
                    <td className="py-2.5 border-none"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div>
              <table className="w-full text-[12px] border-none mb-4">
                <tbody>
                  <tr className="border-b border-gray-100">
                    <td className="py-2 text-gray-500 border-none w-1/2">Amount (excl. tax)</td>
                    <td className="py-2 border-none text-right text-gray-800 font-medium">$2,500.00</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2 text-gray-500 border-none">Amount tax</td>
                    <td className="py-2 border-none text-right text-gray-800 font-medium">$0.00</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2 text-gray-500 border-none">Amount (inc. tax)</td>
                    <td className="py-2 border-none text-right text-gray-800 font-medium">$2,500.00</td>
                  </tr>
                </tbody>
              </table>

              {/* Payments Table */}
              <table className="w-full text-[11px] mb-2 border-collapse">
                <thead>
                  <tr className="bg-[#a6e4e7] border-none text-gray-700">
                    <th className="py-1.5 px-2 font-normal text-left">Payments</th>
                    <th className="py-1.5 px-2 font-normal text-left">Date</th>
                    <th className="py-1.5 px-2 font-normal text-left">Type</th>
                    <th className="py-1.5 px-2 font-normal text-left">Bank account</th>
                    <th className="py-1.5 px-2 font-normal text-right">Amount</th>
                    <th className="py-1.5 px-2 font-normal text-center w-8"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100">
                    <td className="py-1.5 px-2 text-gray-800">Payment</td>
                    <td className="py-1.5 px-2 text-gray-800">05/21/2026</td>
                    <td className="py-1.5 px-2 text-gray-800">Bank transfer</td>
                    <td className="py-1.5 px-2 text-teal-700">BOC</td>
                    <td className="py-1.5 px-2 text-right text-gray-800">2,500.00</td>
                    <td className="py-1.5 px-2 text-center w-8"><FiEye className="cursor-pointer text-[#0000a0]" /></td>
                  </tr>
                </tbody>
              </table>

              <table className="w-full text-[12px] border-none mb-4">
                <tbody>
                  <tr className="border-b border-gray-100">
                    <td className="py-1.5 text-gray-400 border-none text-right pr-4">Already paid (without credit notes and down payments)</td>
                    <td className="py-1.5 border-none text-right text-gray-800 w-24">2,500.00</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-1.5 text-gray-400 border-none text-right pr-4">Billed</td>
                    <td className="py-1.5 border-none text-right text-gray-800 w-24">2,500.00</td>
                  </tr>
                  <tr>
                    <td className="py-3 text-gray-500 border-none text-right pr-4 font-medium">Remaining unpaid</td>
                    <td className="py-3 border-none text-right text-[#008000] font-bold text-[26px] leading-none w-24">0.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Description Table */}
          <div className="mt-8 overflow-x-auto">
            <table className="min-w-full text-[12px] border-collapse">
              <thead>
                <tr className="bg-[#a6e4e7] border-none text-gray-700">
                  <th className="py-2 px-3 font-normal text-left">Description</th>
                  <th className="py-2 px-3 font-normal text-right">TAX</th>
                  <th className="py-2 px-3 font-normal text-right">U.P. (net)</th>
                  <th className="py-2 px-3 font-normal text-center">Qty</th>
                  <th className="py-2 px-3 font-normal text-right">Disc.</th>
                  <th className="py-2 px-3 font-normal text-right leading-tight">Cost<br/>price</th>
                  <th className="py-2 px-3 font-normal text-right leading-tight">Margin<br/>rate</th>
                  <th className="py-2 px-3 font-normal text-right">Total (excl.)</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="py-2.5 px-3 border-none text-gray-800">
                    <FiBox className="inline mr-1.5 text-[#a08a50] text-sm" />
                    C.R.P._MASK - C.R.P. MASK
                  </td>
                  <td className="py-2.5 px-3 border-none text-right text-gray-800">0%</td>
                  <td className="py-2.5 px-3 border-none text-right text-gray-800">250.00</td>
                  <td className="py-2.5 px-3 border-none text-center text-gray-800">20</td>
                  <td className="py-2.5 px-3 border-none text-right text-gray-800">50%</td>
                  <td className="py-2.5 px-3 border-none text-right text-gray-800">65.00</td>
                  <td className="py-2.5 px-3 border-none text-right text-gray-800">48.00%</td>
                  <td className="py-2.5 px-3 border-none text-right text-gray-800">2,500.00</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Bottom Action Bar */}
        <div className="bg-[#a6e4e7] p-3 flex justify-center space-x-2 border-t border-[#8ed1d4] mt-auto">
          <button className="bg-white hover:bg-gray-50 text-gray-700 px-4 py-1.5 rounded-[3px] text-[11px] font-bold tracking-wide transition-colors border border-gray-300 shadow-sm">SEND EMAIL</button>
          <button className="bg-white hover:bg-gray-50 text-gray-700 px-4 py-1.5 rounded-[3px] text-[11px] font-bold tracking-wide transition-colors border border-gray-300 shadow-sm">CLASSIFY 'UNPAID'</button>
          <button className="bg-white hover:bg-gray-50 text-gray-700 px-4 py-1.5 rounded-[3px] text-[11px] font-bold tracking-wide transition-colors border border-gray-300 shadow-sm">CREATE CREDIT NOTE</button>
          <button className="bg-white hover:bg-gray-50 text-gray-700 px-4 py-1.5 rounded-[3px] text-[11px] font-bold tracking-wide transition-colors border border-gray-300 shadow-sm">CLONE</button>
          <button className="bg-white hover:bg-red-50 text-red-600 px-4 py-1.5 rounded-[3px] text-[11px] font-bold tracking-wide transition-colors border border-gray-300 shadow-sm">DELETE</button>
        </div>

        {/* Floating Action Menu */}
        <div className="fixed right-4 top-1/2 -translate-y-1/2 flex flex-col space-y-3 z-50">
          <div className="w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 cursor-pointer hover:bg-gray-50 text-gray-600">
            <FiBookOpen className="text-[17px]" />
          </div>
          <div className="w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 cursor-pointer hover:bg-gray-50 text-gray-600">
            <FaLanguage className="text-[17px]" />
          </div>
          <div className="w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 cursor-pointer hover:bg-gray-50 text-gray-600">
            <FiTarget className="text-[17px]" />
          </div>
          <div className="w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 cursor-pointer hover:bg-gray-50 text-gray-600">
            <FiGrid className="text-[17px]" />
          </div>
          <div className="w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center border-2 border-[#0000a0] cursor-pointer hover:bg-blue-50 text-[#0000a0]">
            <FiEye className="text-[17px]" />
          </div>
        </div>
      </div>
    </div>
  );
}